import { SplashScreen } from './splash-screen'

export default SplashScreen
